// src/Components/Details/hooks/useBettingData.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { createApiUrl } from '../../../Config/apiConfig';

const calculateTimestamps = () => {
    const now = Date.now();
    const from = now - 7 * 24 * 60 * 60 * 1000;
    return { from, to: now };
};

const useBettingData = (serverDetails) => {
    const [activeLast7Days, setActiveLast7Days] = useState("Checking...");

    useEffect(() => {
        const fetchBettingData = async () => {
            console.log('Attempting to fetch betting data for:', serverDetails);

            if (!serverDetails?.ServerID) {
                console.log('No ServerID found, skipping fetch');
                return;
            }

            const { from, to } = calculateTimestamps();
            const payload = {
                queries: [
                    {
                        bucketAggs: [
                            {
                                field: "site.keyword",
                                id: "5",
                                settings: { min_doc_count: 1, order: "desc", orderBy: "_term", size: 10 },
                                type: "terms",
                            },
                            {
                                field: "sessionProductId",
                                id: "4",
                                settings: { min_doc_count: 1, order: "desc", orderBy: "_term", size: 10 },
                                type: "terms",
                            },
                            {
                                field: "@timestamp",
                                id: "2",
                                settings: { interval: "1m", min_doc_count: 0, trimEdges: 0 },
                                type: "date_histogram",
                            },
                        ],
                        datasource: { type: "elasticsearch", uid: "vQq87WtGz" },
                        metrics: [{ field: "select field", id: "1", type: "count" }],
                        query: `source_service:"wager" AND sessionProductId:("${serverDetails.ServerID}")`,
                        refId: "A",
                        timeField: "@timestamp",
                        datasourceId: 9,
                        intervalMs: 30000,
                        maxDataPoints: 563,
                    },
                ],
                from: from.toString(),
                to: to.toString(),
            };

            try {
                console.log('Making API request with payload:', payload);
                const response = await axios.post(
                    createApiUrl('ds/query?ds_type=elasticsearch&requestId=mixed-0-SQR103'),
                    payload
                );
                console.log('Received response:', response.data);

                const frames = response.data?.results?.A?.frames || [];
                setActiveLast7Days(frames.length === 0
                    ? "No Betting Data in Last 7 Days"
                    : "Active Betting in Last 7 Days"
                );
            } catch (error) {
                console.error("Error fetching betting data:", error);
                setActiveLast7Days("Error fetching data");
            }
        };

        fetchBettingData();
    }, [serverDetails?.ServerID]); // Changed dependency to specifically track ServerID

    return activeLast7Days;
};

export default useBettingData;